import React, { ReactElement, useState, useEffect } from 'react';
import LoadingIndicator from '@/components/LoadingIndicator/LoadingIndicator';
import styles from '@/components/MultiLivestream/MultiLivestream.module.scss';
type MultiLivestreamPlayerProps = {
  basePlayerUrl: string;
  selectedChannel: string;
  userSelectedChannel: string;
};
const MultiLivestreamPlayer = (props: MultiLivestreamPlayerProps): ReactElement => {
  const {
    basePlayerUrl,
    selectedChannel,
    userSelectedChannel
  } = props;
  const [playerUrl, setPlayerUrl] = useState<string | undefined>(undefined);

  // when a new channel is selected, update the livestream player URL
  useEffect(() => {
    const url = new URL(basePlayerUrl);
    url.searchParams.set('feed_cid', userSelectedChannel || selectedChannel);
    if (userSelectedChannel) {
      url.searchParams.set('channel_switch', 'true');
    }
    setPlayerUrl(url.toString());
  }, [basePlayerUrl, userSelectedChannel, selectedChannel]);
  return <section className={styles.multi_livestream__player__container} data-sentry-component="MultiLivestreamPlayer" data-sentry-source-file="MultiLivestreamPlayer.tsx">
      {selectedChannel ? <div className={styles.multi_livestream__player}>
            <iframe src={playerUrl} frameBorder="0" allow="geolocation; encrypted-media" allowFullScreen className={styles.livestream_player__iframe} name="livestream-player"></iframe>
        </div> : <div className={styles.multi_livestream__player__loading}>
          <LoadingIndicator />
        </div>}
    </section>;
};
export default MultiLivestreamPlayer;